import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";
import { WHATSAPP_URL } from "../lib/brand";
import { useQuotePopup } from "../context/QuotePopupContext";

// Bottom-right floating actions: WhatsApp + "Get Wholesale Price"
export const FloatingActions = () => {
  const { openPopup } = useQuotePopup();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Reveal after a short delay so it doesn't fight with hero load
    const t = setTimeout(() => setShow(true), 800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 flex flex-col items-end gap-3"
      data-testid="floating-actions"
    >
      {/* Get Wholesale Price button */}
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 30 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            onClick={openPopup}
            data-testid="floating-quote-btn"
            aria-label="Get wholesale price"
            className="group relative flex items-center gap-2 pl-4 pr-5 py-3 bg-[#0E4D3D] text-[#C9A227] border border-[#C9A227] hover:bg-[#C9A227] hover:text-[#0E4D3D] transition-all duration-300 shadow-[0_18px_40px_-18px_rgba(14,77,61,0.6)]"
          >
            <Sparkles className="w-4 h-4" strokeWidth={1.6} />
            <span className="label-overline">Get Wholesale Price</span>
            <span className="absolute -top-2 -right-2 w-3 h-3 rounded-full bg-[#C9A227] group-hover:bg-[#0E4D3D]">
              <span className="absolute inset-0 rounded-full bg-[#C9A227] animate-ping opacity-60" />
            </span>
          </motion.button>
        )}
      </AnimatePresence>

      {/* WhatsApp button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="relative group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] pulse-ring" />
        <span className="relative flex items-center justify-center w-14 h-14 md:w-[60px] md:h-[60px] rounded-full bg-[#25D366] shadow-[0_12px_40px_-10px_rgba(37,211,102,0.7)] group-hover:scale-110 transition-transform duration-300">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-7 h-7 md:w-8 md:h-8 fill-white"
            aria-hidden="true"
          >
            <path d="M20.52 3.48A11.86 11.86 0 0 0 12.01.05C5.5.05.16 5.39.16 11.9c0 2.1.55 4.14 1.6 5.95L0 23.95l6.27-1.65a11.83 11.83 0 0 0 5.73 1.46h.01c6.51 0 11.85-5.34 11.85-11.85 0-3.17-1.24-6.15-3.34-8.43zM12.02 21.7h-.01a9.7 9.7 0 0 1-4.95-1.36l-.36-.21-3.72.98.99-3.63-.23-.37a9.74 9.74 0 0 1-1.49-5.21c0-5.39 4.39-9.78 9.78-9.78 2.61 0 5.07 1.02 6.92 2.87a9.71 9.71 0 0 1 2.86 6.92c0 5.39-4.39 9.79-9.79 9.79zm5.36-7.32c-.29-.15-1.73-.86-2-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.15-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.59.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.2 3.03c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.67.62.7.22 1.34.19 1.85.12.56-.08 1.73-.71 1.97-1.39.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34z" />
          </svg>
        </span>
      </a>
    </div>
  );
};
